// @flow

import React from 'react'

const FiltersContext = React.createContext()

export const FiltersContextProvider = FiltersContext.Provider
export const FiltersContextConsumer = FiltersContext.Consumer

export default FiltersContext